var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters || _vm.activeLetter),expression:"showFilters || activeLetter"}],staticClass:"nuttrema-index-letters"},[_c('ul',_vm._l((_vm.alphabet),function(letter){return _c('li',[_c('a',{class:{ 'is-active': _vm.activeLetter === letter },on:{"click":function($event){_vm.handleFilterByFirstLetter(letter)}}},[_vm._v(_vm._s(_vm._f("upper")(letter)))])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11950a38","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/panels/nuttrema-filter-by-letters.vue
// module id = 2932
// module chunks = 0